import type { FC } from 'react'

export const NotFound: FC = () => (
  <main className='flex flex-col items-center justify-center p-8'>
    <h1 className='text-4xl font-bold text-center mb-8'>404: Not Found</h1>
    <p className='text-xl'>
      Sorry, the page you are looking for does not exist.
    </p>
  </main>
)

export default NotFound
